var products = {
    burpiMain: document.getElementById("product-form-template--15578139328727__main"),
    anyForBurpi: document.getElementById("product-form-7508438352087"),
    burpiForBurpi: document.getElementById("product-form-7508437532887")
}

var identifiers = {
    anyForBurpieMain: document.querySelector('[value="42291618742487"]'),
    burpiForBurpieMain: document.querySelector('[value="42291617267927"]'),
    burpiMoreMain: document.querySelector('[value="42285542211799"]'),
}

var productLocation = {

    productPage: document.getElementById("shopify-section-template--15578139328727__main"),
    homePage: document.getElementById("shopify-section-template--15578138706135__16423930125d540304"),
    cartPage: document.getElementById("shopify-section-template--15578138378455__cart-items"),
    
}
 
var popupDismissed = Cookies.get('add_burpi');


if (productLocation.homePage || productLocation.cartPage) {

    var triggers = {
    
        anyForBurpi: products.anyForBurpi.querySelector('button[type=submit]'),
        burpiForBurpi: products.burpiForBurpi.querySelector('button[type=submit]'),
    
    }

    triggers.anyForBurpi.onclick = function (){
        addonPopup();
    };

    if (popupDismissed !== 'dismissed') {
        triggers.burpiForBurpi.addEventListener('click', function() {
            addonPopup();
            setCookie();
        }, { once: true });
    }
  

} else if (productLocation.productPage) {
    var triggers = {
        burpiMain: products.burpiMain.querySelector('button[type=submit]')
    }

    if (identifiers.anyForBurpieMain !== null) {
        triggers.burpiMain.onclick = function (){
            addonPopup();
        };
    } else if (identifiers.burpiForBurpieMain !== null) {
        if (popupDismissed !== 'dismissed') {
            triggers.burpiMain.addEventListener('click', function() {
                addonPopup();
                setCookie();
            }, { once: true });
        }
    }
  
    
}

function addonPopup () {
    setTimeout( function() {
        
        Swal.fire({
          
            html:
              ` <div id="addon-sale-popup">
              <div class="grid__item">
                  <div class="product-card__wrapper">
                      <div class="product-card__inner">
                      <p class="product-card__description rte "> Add some "Back-up" Burpi cylinders to your order so you never run out! </p>
                      <div class="product-card__content ">
                          <div class="product-card__information">
                          <h3 class="product-card__heading"> More Burpi's </h3>
                          <div class="price ">
                              <div class="price__container">
                              <div class="price__regular">
                                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                  <span class="price-item price-item--regular"> $29.00 </span>
                              </div>
                              <div class="price__sale">
                                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                  <span>
                                  <s class="price-item price-item--regular"></s>
                                  </span>
                                  <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                  <span class="price-item price-item--sale price-item--last"> $29.00 </span>
                              </div>
                              <small class="unit-price caption hidden">
                                  <span class="visually-hidden">Unit price</span>
                                  <span class="price-item price-item--last">
                                  <span></span>
                                  <span aria-hidden="true">/</span>
                                  <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                  <span></span>
                                  </span>
                              </small>
                              </div>
                          </div>
                          <div class="product-form__input product-form__quantity">
                              <label class="form__label visually-hidden" for="Quantity-template--15578138706135__16423930125d540304"> Quantity </label>
                              <quantity-input class="quantity">
                              <button class="quantity__button no-js-hidden" name="minus" type="button">
                                  <span class="visually-hidden">Decrease quantity for </span>
                                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 20 20">
                                  <path d="M18.8 8.99899L11.022 9.02299L8.648 8.99899H1.2C0.88174 8.99899 0.576516 9.12542 0.351472 9.35046C0.126428 9.57551 0 9.88073 0 10.199C0 10.5173 0.126428 10.8225 0.351472 11.0475C0.576516 11.2726 0.88174 11.399 1.2 11.399H18.8C19.1183 11.399 19.4235 11.2726 19.6485 11.0475C19.8736 10.8225 20 10.5173 20 10.199C20 9.88073 19.8736 9.57551 19.6485 9.35046C19.4235 9.12542 19.1183 8.99899 18.8 8.99899Z" fill="currentColor"></path>
                                  </svg>
                              </button>
                              <input class="quantity__input" type="number" name="quantity" id="Quantity-7506520506583" min="1" value="1" form="product-form-7506520506583">
                              <button class="quantity__button no-js-hidden" name="plus" type="button">
                                  <span class="visually-hidden">Increase quantity for </span>
                                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 20 21">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.82344 9.00077L8.79999 1.39901C8.79999 1.08075 8.92642 0.77552 9.15146 0.550476C9.3765 0.325432 9.68173 0.199005 9.99999 0.199005C10.3182 0.199005 10.6235 0.325432 10.8485 0.550476C11.0736 0.77552 11.2 1.08075 11.2 1.39901V9.02244L18.8 8.99899C19.1183 8.99899 19.4235 9.12542 19.6485 9.35046C19.8736 9.57551 20 9.88073 20 10.199C20 10.5173 19.8736 10.8225 19.6485 11.0475C19.4235 11.2726 19.1183 11.399 18.8 11.399H11.2V18.999C11.2 19.3173 11.0736 19.6225 10.8485 19.8475C10.6235 20.0726 10.3182 20.199 9.99999 20.199C9.68173 20.199 9.3765 20.0726 9.15146 19.8475C8.92642 19.6225 8.79999 19.3173 8.79999 18.999V11.551L8.80152 11.399H1.2C0.88174 11.399 0.576516 11.2726 0.351472 11.0475C0.126428 10.8225 0 10.5173 0 10.199C0 9.88073 0.126428 9.57551 0.351472 9.35046C0.576516 9.12542 0.88174 8.99899 1.2 8.99899H8.648L8.82344 9.00077Z" fill="currentColor"></path>
                                  </svg>
                              </button>
                              </quantity-input>
                              <product-form class="product-form">
                              <div class="product-form__error-message-wrapper" role="alert" hidden="">
                                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                                  <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                                  <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                                  <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                                  <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
                                  </svg>
                                  <span class="product-form__error-message"></span>
                              </div>
                              <form method="post" action="/cart/add" id="product-form-7506520506583" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                  <input type="hidden" name="form_type" value="product">
                                  <input type="hidden" name="utf8" value="✓">
                                  <input type="hidden" name="id" value="42285542211799">
                                  <div class="product-form__buttons">
                                  <button type="submit" name="add" class="product-form__submit button button--rounder">
                                      <span> Add to cart </span>
                                      <svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.411 39.508" fill="none">
                                      <g fill="currentColor">
                                          <path d="M37.712 29.631H19.946a5.742 5.742 0 0 1-5.527-4.089L8.413 5.193a1.778 1.778 0 0 0-1.732-1.242H1.975a1.975 1.975 0 0 1 0-3.951h4.706a5.739 5.739 0 0 1 5.525 4.089L13.33 7.9h30.214a3.9 3.9 0 0 1 3.127 1.57 3.732 3.732 0 0 1 .569 3.35l-4.076 12.937a5.733 5.733 0 0 1-5.452 3.874Zm5.833-17.779h.02Z"></path>
                                          <path d="M21.73 39.506a3.951 3.951 0 1 1 3.949-3.949 3.955 3.955 0 0 1-3.949 3.949Zm0-3.953Z"></path>
                                          <path d="M35.557 39.506a3.951 3.951 0 1 1 3.949-3.949 3.955 3.955 0 0 1-3.949 3.949Zm0-3.953Z"></path>
                                      </g>
                                      </svg>
                                      <div class="loading-overlay__spinner hidden">
                                      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                      </svg>
                                      </div>
                                  </button>
                                  </div>
                              </form>
                              </product-form>
                          </div>
                          <a href="/products/universal-burpi-co2-cylinder" class="product-card__clickable">
                              <span class="visually-hidden">More Burpi's</span>
                          </a>
                          </div>
                          <div class="product-card__media">
                          <div class="media media--transparent">
                              <a href="/products/universal-burpi-co2-cylinder" title="More Burpi's">
                              <span class="visually-hidden">More Burpi's</span>
                              </a>
                              <img srcset="//cdn.shopify.com/s/files/1/0620/5335/1639/products/burpi-cylinder_165x.png?v=1647731048 165w,//cdn.shopify.com/s/files/1/0620/5335/1639/products/burpi-cylinder_360x.png?v=1647731048 360w,//cdn.shopify.com/s/files/1/0620/5335/1639/products/burpi-cylinder_533x.png?v=1647731048 533w,//cdn.shopify.com/s/files/1/0620/5335/1639/products/burpi-cylinder_720x.png?v=1647731048 720w,//cdn.shopify.com/s/files/1/0620/5335/1639/products/burpi-cylinder.png?v=1647731048 752w" src="//cdn.shopify.com/s/files/1/0620/5335/1639/products/burpi-cylinder_533x.png?v=1647731048" sizes="(min-width: 1160px) 257px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="More Burpi's" loading="lazy" class="motion-reduce" width="752" height="752">
                          </div>
                          </div>
                      </div>
                      </div>
                  </div>
              </div>
          </div>`,
            showCloseButton: true
          });
    
        }, "3000");
}

function setCookie() {
    Cookies.set('add_burpi', 'dismissed', { expires: 30 });
} 